import React, { useState } from "react";
import FooterOne from "../common/footer/FooterOne";
import SEO from "../common/SEO";
import API_URL from "../common/config";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HeaderFour from "../common/header/HeaderFour";
import API_URL_dash from "../common/config2";

const InstructorLogin = () => {
  const [email, setUsernameOrEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError(""); // Clear any previous errors
    setIsLoading(true);

    console.log("Sending login request with:", email);

    try {
      const response = await axios.post(`${API_URL}/api/auth/login`, {
        email,
        password,
      });

      console.log("Login response:", response);

      if (response.status === 200) {
        const { token, user } = response.data;

        console.log("User data:", user);

        localStorage.setItem("token", token);
        localStorage.setItem("userId", user.id);
        localStorage.setItem("userType", user.userType);

        if (user.userType === "Instructor") {
          handleNavigation();
        } else {
          setLoginError("Access denied. Only instructors can login here.");
        }
      }
    } catch (error) {
      console.error(
        "Login error:",
        error.response?.data?.message || "Server error"
      );
      setLoginError(
        error.response?.data?.message || "Invalid email or password"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleNavigation = () => {
    try {
      // Get user data from localStorage
      const userId = localStorage.getItem("userId");
      const userType = localStorage.getItem("userType");
      const token = localStorage.getItem("token");

      // Check if we have the essential data
      if (userId) {
        // Create a proper JSON string for userData
        const userData = JSON.stringify({ id: userId, userType });

        // Properly encode the parameters
        const encodedUserData = encodeURIComponent(userData);
        const encodedToken = token ? encodeURIComponent(token) : "";

        // Create the dashboard URL with correctly formatted parameters
        const dashboardUrl = `${API_URL_dash}/instructor-dashboard?userData=${encodedUserData}`;

        // Add token if available
        const finalUrl = encodedToken
          ? `${dashboardUrl}&token=${encodedToken}`
          : dashboardUrl;

        console.log("Redirecting to dashboard:", finalUrl);

        // Redirect to the dashboard
        window.location.href = finalUrl;
      } else {
        console.error("Missing authentication data for dashboard navigation");
        // Fallback - redirect to login
        window.location.href = "/login";
      }
    } catch (error) {
      console.error("Error navigating to dashboard:", error);
      // Fallback - redirect to login
      window.location.href = "/login";
    }
  };

  return (
    <>
      <SEO />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderFour />

        <div
          className="pt--250 pt_lg--200 pt_md--100 pt_sm--80 case-study-page-area"
          style={{
            height: "100vh",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <h4>Instructor Login</h4>
                <hr />

                {loginError && (
                  <div className="alert alert-danger" role="alert">
                    {loginError}
                  </div>
                )}

                <form onSubmit={handleLogin} className="axil-contact-form">
                  <div className="form-group">
                    <label>Email address*</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="name@example.com"
                      name="email"
                      value={email}
                      onChange={(e) => setUsernameOrEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Password*</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="••••••••"
                      name="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="rememberMe"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="rememberMe">
                        Remember me
                      </label>
                    </div>
                  </div>

                  <div className="form-group">
                    <button
                      type="submit"
                      className="axil-btn btn-fill-primary btn-fluid btn-primary"
                      name="submit-btn"
                      disabled={isLoading}
                    >
                      {isLoading ? "Processing..." : "Log In"}
                    </button>
                  </div>

                  <div className="form-group text-center">
                    <a href="#" className="link-primary">
                      Forgot password?
                    </a>
                  </div>
                </form>
              </div>

              <div className="col-md-6 offset-md-2">
                <img
                  src="/images/banner/banner-thumb-3.png"
                  className="img-responsive"
                  alt="Instructor Login"
                />
              </div>
            </div>
          </div>
        </div>

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default InstructorLogin;
